










import { Vue, Component } from 'vue-property-decorator';

@Component
export default class NotFoundView extends Vue {
  private onRouteClick(route: string): Promise<any> {
    return this.$router.push(`/${route}`);
  }
}
